import { ConsultationDrevComponent } from './consultation-drev.component';

export const CONSULTATION_DREV_ROUTES = [
    { path: '', component: ConsultationDrevComponent, data: { menu: { libelle: 'Drev AOC / DR IGP' } } },
    { path: ':annee', component: ConsultationDrevComponent }
];
